const Form = ({ onSubmit, formData, children, ...props }) => {
  const handleSubmit = evento => {
    evento.preventDefault()
    const isValid = Object.values(formData).every(
      data => data.isValid !== false
    )

    const values = Object.keys(formData).reduce(
      (data, key) => ({ ...data, [key]: formData[key].value }),
      {}
    )

    onSubmit({ values, isValid })
  }

  return (
    <form onSubmit={handleSubmit} {...props}>
      {children}
    </form>
  )
}

export { Form }
